import React from "react";


import { connect } from "react-redux";
import CommonTitleHeader from "../commonTitleComponent/commonTitleHeader";
import Footer from "../footerComponent/Footer";
import Header from "../headerComponent/Header";
import LeftMenu from "../leftSideComponent/LeftSide";
import BankSteps from "./BankSteps";
import BankToBankTransferDetails from "./BankToBankTransferDetails";
import PaymentFilter from "./PaymentFilter";
import PaymentStaticTxt from "./PaymentStaticTxt";


class PaymentFillUp extends React.Component{
    constructor(props){
        super(props);
        this.state={
			phoneNo: this.props.phone,
		
		}
    }

	
    componentDidMount(){}
	componentWillUnmount(){
    }

  render(){
    console.log('Inside render');
	var headerTitle="Payment Details";
    return(
   
        <div class="row">
				<div class="col-12 col-lg-8">
					<div class="card">
						<CommonTitleHeader headerTitle={headerTitle}/>
						<PaymentFilter/>
						<PaymentStaticTxt/>
					</div>
				</div>
				<BankToBankTransferDetails/>
				<BankSteps/>
		</div>

		);
      } 
}

const mapStateToProps = (
	{ errorMessageReduce:{errorMessage,loginErrorMessage,otpErrorMessage},
	 miscReduce:{otpRefNo,phone}}
	) => ({
		errorMessage,loginErrorMessage,otpErrorMessage,otpRefNo,phone
});

export default connect(mapStateToProps, null)(PaymentFillUp);
